const translations = {
    headerTitle: {
        type: 'text',
        defaultValue: '<b>Zresetuj</b> hasło',
    },
    headerDescription: {
        type: 'text',
        defaultValue: 'Wpisz adres mailowy Twojego konta, a prześlemy na niego link do resetu hasła.',
    },
    inputPassword: {
        type: 'text',
        defaultValue: 'Hasło',
    },
    inputRepeatPassword: {
        type: 'text',
        defaultValue: 'Powtórz hasło',
    },
    buttonPasswordVisible: {
        type: 'text',
        defaultValue: 'Pokaż hasło',
    },
    buttonPasswordInvisible: {
        type: 'text',
        defaultValue: 'Ukryj hasło',
    },
    buttonSubmit: {
        type: 'text',
        defaultValue: 'Zmień hasło',
    },
    successSendEmail: {
        type: 'text',
        defaultValue: '<span>Przesłaliśmy na <b>wskazany adres email</b> link do resetu hasła.</span>',
    },
    headerSuccess: {
        type: 'text',
        defaultValue: 'Hasło zostało zmienione',
    },
    buttonRedirect: {
        type: 'text',
        defaultValue: 'Przejdź do panelu {name}',
    },
    patient: {
        type: 'text',
        defaultValue: 'Pacjenta',
    },
    physio: {
        type: 'text',
        defaultValue: 'Fizjoterapeuty',
    },
    buttonHomePage: {
        type: 'text',
        defaultValue: 'Przejdź do strony głównej',
    },
};

export default translations;
